import axios from "../axiosClient";

export const getRoles = async (
  PageNumber: any,
  pageSize: any,
  SortBy: any,
  SortDirection: any,
  searchText: any,
  signal: any
) => {
  const res = await axios.get(`/slpapp/Role/getall`, {
    params: { PageNumber, pageSize, searchText, SortBy, SortDirection },
    signal,
  });

  return res?.data;
};
